import { infoSlider } from './module/infoSlider';
infoSlider();

import { achievementsSlider } from './module/achievementsSlider';
achievementsSlider();